export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14484.f56a89a1.jpg";